export default "__VITE_ASSET__e0107b16__"